// Track which drills the user has opened. localStorage-only; scoped by hub track
// (pa/vi/fn) so a drill can't accidentally collide with a differently-named one.
const KEY = 'gntl:drills-seen';

function readAll() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return typeof parsed === 'object' && parsed ? parsed : {};
  } catch {
    return {};
  }
}

export function isDrillSeen(id) {
  return Boolean(readAll()[id]);
}

export function markDrillSeen(id) {
  if (!id) return;
  const all = readAll();
  if (all[id]) return;
  all[id] = new Date().toISOString();
  try {
    localStorage.setItem(KEY, JSON.stringify(all));
  } catch {
    /* quota errors etc — safe to ignore */
  }
}

// Bulk read for hydrating hub UI in one shot.
export function getSeenMap() {
  return readAll();
}
